import Awesomplete from 'awesomplete';
import { breakpoints, keyboardKeyCodes } from '../../scripts/globals';
import toArray from '../../scripts/to-array';

const allLocationsLabel = 'All locations';

function getJobsByDataAttr(source) {
  const jobs = toArray(document.querySelectorAll('[data-job]'));

  if (!jobs) {
    return [];
  }

  const list = Object.keys(jobs.reduce((acc, job) => {
    if (!job.dataset[source]) {
      return acc;
    }

    job.dataset[source].split('|').forEach((tag) => { acc[tag] = true; });
    return acc;
  }, {})).sort();

  return source === 'location' ? [allLocationsLabel, ...list] : list;
}

toArray(document.querySelectorAll('[data-component="careers-search"]')).forEach((container) => {
  const form = document.querySelector('[data-careers-search-form]');
  const submitButton = document.querySelector('[data-careers-search-submit]');
  const roleInput = document.querySelector('[data-careers-search-role]');
  const locationInput = document.querySelector('[data-careers-search-location]');
  const locationSelect = document.querySelector('[data-careers-search-location-select]');
  const positionsContainer = document.querySelector('[data-component="careers-positions"]');
  const resultsList = document.querySelector('[data-careers-search-results-list]');
  const resultsNumber = document.querySelector('[data-careers-search-results-number]');
  const resultsTitle = document.querySelector('[data-careers-search-results-title]');
  const noResultsTitle = document.querySelector('[data-careers-search-no-results-title]');
  const resultsClose = document.querySelector('[data-careers-search-results-close]');
  const jobs = toArray(document.querySelectorAll('[data-job]'));

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    if (!roleInput.value) {
      return;
    }

    const roleValue = roleInput.value;
    const locationValue = window.innerWidth < breakpoints.tablet ?
      locationSelect.value : locationInput.value;

    const filteredJobs = jobs.filter(item =>
      item.dataset.tags &&
      item.dataset.tags.match(new RegExp(roleValue, 'i')) &&
      (item.dataset.location.split('|').indexOf(locationValue) >= 0 || !locationValue.length || locationValue === allLocationsLabel));

    resultsNumber.innerText = filteredJobs.length;
    resultsList.innerHTML = '';

    positionsContainer.classList.add('is-search');

    if (filteredJobs.length) {
      resultsTitle.classList.add('is-active');
      noResultsTitle.classList.remove('is-active');

      filteredJobs.forEach((item) => {
        resultsList.appendChild(item.cloneNode(true));
      });
    } else {
      resultsTitle.classList.remove('is-active');
      noResultsTitle.classList.add('is-active');
    }
  });

  resultsClose.addEventListener('click', () => {
    positionsContainer.classList.remove('is-search');
  });

  function validateForm() {
    if (roleInput.value) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', 'disabled');
    }
  }

  if (locationSelect) {
    locationSelect.innerHTML = getJobsByDataAttr('location').reduce((acc, item) => `${acc}<option>${item}</option>`, '');
  }

  toArray(container.querySelectorAll('[data-careers-search-auto-complete]')).forEach((component) => {
    const input = component.querySelector('[data-careers-search-input]');
    const select = component.querySelector('[data-careers-search-select]');
    const dropButton = component.querySelector('[data-careers-search-drop-button]');

    const autocomplete = new Awesomplete(input, {
      minChars: dropButton ? 0 : 2,
      list: input.dataset.autocompleteList ?
        input.dataset.autocompleteList.split('|') :
        getJobsByDataAttr(input.dataset.source),
      sort: input.dataset.autocompleteList,
    });

    component.addEventListener('awesomplete-open', () => {
      if (!container) {
        return;
      }
      component.classList.add('is-open');
      container.classList.add('is-open');
    });

    component.addEventListener('awesomplete-selectcomplete', () => {
      validateForm();
      input.blur();
    });

    component.addEventListener('awesomplete-close', () => {
      if (!container) {
        return;
      }

      validateForm();
      setTimeout(() => {
        component.classList.remove('is-open');
        container.classList.remove('is-open');
      }, 100);
    });

    input.addEventListener('change', () => {
      validateForm();
    });

    if (dropButton) {
      input.addEventListener('focus', () => {
        input.value = '';
        autocomplete.evaluate();
        autocomplete.open();
      });

      dropButton.addEventListener('focus', () => {
        input.value = '';
        setTimeout(() => {
          if (autocomplete.ul.childNodes.length === 0) {
            autocomplete.minChars = 0;
            autocomplete.evaluate();
            autocomplete.next();
          } else if (!component.classList.contains('is-open')) {
            autocomplete.open();
            autocomplete.next();
          }
        }, 100);
      });

      dropButton.addEventListener('click', () => {
        setTimeout(() => {
          autocomplete.close();
        }, 1);
      });

      dropButton.onkeydown = (e) => {
        if (!component.classList.contains('is-open')) {
          return;
        }

        if (e.keyCode === keyboardKeyCodes.arrowDown) {
          e.preventDefault();
          autocomplete.next();
        } else if (e.keyCode === keyboardKeyCodes.arrowUp) {
          e.preventDefault();
          autocomplete.previous();
        } else if (e.keyCode === keyboardKeyCodes.return) {
          e.preventDefault();
          autocomplete.select();
        }
      };
    }

    if (select) {
      select.addEventListener('change', () => {
        select.classList.add('is-selected');
      });
    }
  });
});
